import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase
  .initializeApp({
    apiKey: "AIzaSyAydEgjv1ozOyfsKNYK-tTSuy_sHQ0FNYU",
    authDomain: "react-chat-2bb0f.firebaseapp.com",
    projectId: "react-chat-2bb0f",
    storageBucket: "react-chat-2bb0f.appspot.com",
    messagingSenderId: "151889629237",
    appId: "1:151889629237:web:2cafdf5b5c4373d358e17c",
  })
  .auth();
